export default __webpack_public_path__ + "static/media/greek_salad_dressing.f02f62b4.jpeg";